import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "client/slices/authSlice";
import { updateTotalItem } from "client/slices/cartSlice";
import { MainLogo } from "components/Images";
import Header from "portal/components/Header/Header";
import { NotificationsProvider } from "portal/hooks/useNotifications";
import allRoutes from "client/constants/allRoutes";

const navItems = [
  {
    label: "Dashboard",
    path: allRoutes.superadmin,
    end: true,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Clinics",
    path: allRoutes.superadminClinics,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Subscriptions",
    path: allRoutes.superadminSubscriptions,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Plans",
    path: allRoutes.superadminPlans,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Revenue",
    path: allRoutes.superadminRevenue,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Cross-Branch",
    path: allRoutes.superadminCrossBranch,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Activity Logs",
    path: allRoutes.superadminActivityLogs,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Usage Stats",
    path: allRoutes.superadminUsageStats,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-5h2v5zm4 0h-2V7h2v10zm4 0h-2v-3h2v3z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Payments",
    path: allRoutes.superadminPaymentFailures,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Support Tickets",
    path: allRoutes.superadminSupportTickets,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM11 5h2v4h-2V5zm0 6h2v2h-2v-2z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Testimonials",
    path: allRoutes.superadminTestimonials,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l2.4 4.86 5.37.78-3.89 3.79.92 5.34L12 14.42 7.2 16.77l.92-5.34L4.23 7.64l5.37-.78L12 2z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    label: "Newsletter",
    path: allRoutes.superadminNewsletter,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
      </svg>
    ),
  },
];

const SuperAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const handleLogout = () => {
    setIsLogoutModalOpen(false);
    dispatch(logout());
    dispatch(updateTotalItem());
    navigate(allRoutes.home);
  };

  return (
    // Header reads the shared badge from this provider; without it Header throws.
    <NotificationsProvider>
    <div className="flex h-screen bg-surface-bg overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Dark Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-slate-900 lg:translate-x-0 lg:static lg:inset-0 ${
          sidebarOpen ? "translate-x-0 ease-out" : "-translate-x-full ease-in"
        }`}
      >
        {/* Logo + Super Admin badge */}
        <div className="flex items-center justify-center h-[71px] border-b border-slate-700/50 px-4">
          <div
            className="flex items-center gap-2.5 cursor-pointer"
            onClick={() => navigate(allRoutes.superadmin)}
          >
            <img src={MainLogo} alt="Logo" className="h-6 brightness-0 invert" />
            <span className="text-white text-[10px] font-bold uppercase tracking-wider bg-indigo-600 px-2 py-1 rounded">
              Super Admin
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex flex-col h-[calc(100vh-71px)] pt-6 px-3">
          {/* Nav Items */}
          <ul className="flex-1 space-y-1">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.end || false}
                  className={({ isActive }) =>
                    `flex items-center px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-white/10 text-white"
                        : "text-slate-400 hover:bg-white/5 hover:text-slate-200"
                    }`
                  }
                >
                  <span className="w-5 h-5 flex-shrink-0">{item.icon}</span>
                  <span className="ml-3">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Footer */}
          <div className="pb-6 pt-4 border-t border-slate-700/50 space-y-1">
            <button
              onClick={() => setIsLogoutModalOpen(true)}
              className="flex items-center w-full px-4 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:bg-red-500/10 hover:text-red-400 transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" fill="currentColor"/>
              </svg>
              <span className="ml-3">Logout</span>
            </button>

            <p className="text-center text-[10px] text-slate-600 pt-4">
              Powered by <span className="text-brand-400 font-medium">Vistaar</span>
            </p>
          </div>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden h-screen bg-surface-card">
        <Header setSidebarOpen={setSidebarOpen} />
        <main className="flex-1 overflow-scroll overflow-x-hidden bg-surface-bg px-page-x py-page-y h-[calc(100vh-70px)]">
          <Outlet />
        </main>
      </div>

      {/* Logout Confirmation Modal */}
      {isLogoutModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setIsLogoutModalOpen(false)} />
          <div className="relative bg-surface-card w-[420px] max-w-[90%] rounded-modal shadow-elevation-3 p-6 animate-fadeIn">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-danger-100">
              <svg className="w-7 h-7 text-danger-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z" />
              </svg>
            </div>
            <h3 className="text-title text-content-primary text-center">Confirm Logout</h3>
            <p className="text-body text-content-secondary text-center mt-2 mb-6">
              Are you sure you want to logout? You will need to login again to access the super admin panel.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={() => setIsLogoutModalOpen(false)}
                className="px-5 py-2.5 text-body font-medium text-content-primary bg-surface-hover rounded-button hover:bg-gray-200 transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="px-5 py-2.5 text-body font-semibold text-white bg-danger-500 rounded-button shadow-elevation-1 hover:bg-danger-600 transition-all"
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </NotificationsProvider>
  );
};

export default SuperAdminLayout;
